function assertRefObject(ref) {
  if (ref && !("current" in ref)) {
    throw new Error("assertRefObject(): Only RefObject's are supported.");
  }
}

export { assertRefObject };
//# sourceMappingURL=assert-ref-object.js.map
